import { toast } from 'react-toastify';

export const Toaster = {
  success: toast.success,
  warn: toast.warn,
  error: toast.error,
  info: toast.info,
};
